<template>
  <span :class="isOverLimit ? skin['over-limit'] : ''">{{ codePoints }}/{{ maxlength }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import skin from './FieldCharacterCount.skin.module.css'

const props = defineProps<{
  /** Current text; its length counts in code points. */
  value: string
  /** Character limit the count is shown against. */
  maxlength: number
}>()

const codePoints = computed(() => Array.from(props.value).length)
const isOverLimit = computed(() => codePoints.value > props.maxlength)
</script>
